import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["aria-label"]
const _hoisted_2 = { class: "step-list" }
const _hoisted_3 = { class: "step-item" }
const _hoisted_4 = { class: "step-item" }
const _hoisted_5 = { class: "step-item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Step = _resolveComponent("Step")!

  return (_openBlock(), _createElementBlock("nav", {
    "aria-label": _ctx.$t('aria.barre.etapes.preavis'),
    class: "step-bar-container"
  }, [
    _createElementVNode("ol", _hoisted_2, [
      _createElementVNode("li", _hoisted_3, [
        _createVNode(_component_Step, {
          number: 1,
          state: _ctx.isActive(1),
          subtitle: _ctx.site?.description ?? '',
          title: _ctx.$t('intervention.bar.site')
        }, null, 8, ["state", "subtitle", "title"])
      ]),
      _cache[0] || (_cache[0] = _createElementVNode("div", {
        "aria-hidden": "true",
        class: "separator"
      }, null, -1)),
      _createElementVNode("li", _hoisted_4, [
        _createVNode(_component_Step, {
          number: 2,
          state: _ctx.isActive(2),
          subtitle: _ctx.equipementsSubtitle,
          title: _ctx.$t('intervention.bar.equipement')
        }, null, 8, ["state", "subtitle", "title"])
      ]),
      _cache[1] || (_cache[1] = _createElementVNode("div", {
        "aria-hidden": "true",
        class: "separator"
      }, null, -1)),
      _createElementVNode("li", _hoisted_5, [
        _createVNode(_component_Step, {
          number: 3,
          state: _ctx.isActive(3),
          title: _ctx.$t('preavisIntervention.saisie')
        }, null, 8, ["state", "title"])
      ])
    ])
  ], 8, _hoisted_1))
}